import React, { Children, Component } from "react";
import PropTypes from "prop-types";
import { Labeled } from "admin-on-rest";
import Avatar from "material-ui/Avatar";
import AccountIcon from "material-ui/svg-icons/action/account-circle";
import { orange200, pink400 } from "material-ui/styles/colors";
import IconButton from "material-ui/IconButton";
import { Box, Flex } from "rebass";
import "./font/fontello.css";
import FontIcon from "material-ui/FontIcon";
import { Tabs, Tab } from "material-ui/Tabs";
import { styles } from "./styles";

import MarketerSales from "./MarketerSales";
import MarketerTransactions from "./MarketerTransactions";
import isNil from "lodash.isnil";
import { convertUrlSocialMedia } from "./utilsMarketer";

class MarketerShowLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.selectedDefault || 0
    };
  }
  handleChange = value => {
    this.setState({ value });
    this.props.setShowButtonAdjust(value);
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.selectedDefault !== nextProps.selectedDefault) {
      this.setState({
        value: nextProps.selectedDefault
      });
    }
  }

  renderProfileInfo = (basePath, children, record, resource) => (
    <div style={styles.profileInfo}>
      <Avatar
        src={record.avatarUrl}
        size={100}
        color={orange200}
        backgroundColor={pink400}
        icon={<AccountIcon />}
      />
      {Children.map(children, field => (
        <div
          key={field.props.source}
          style={field.props.style}
          className={`aor-field-${field.props.source}`}
        >
          {field.props.addLabel ? (
            <Labeled
              record={record}
              resource={resource}
              basePath={basePath}
              label={field.props.label}
              source={field.props.source}
              disabled={false}
            >
              {field}
            </Labeled>
          ) : typeof field.type === "string" ? (
            field
          ) : (
            React.cloneElement(field, { record, resource, basePath })
          )}
        </div>
      ))}
    </div>
  );
  renderSocial = social => (
    <Flex w={[1]} direction={["row"]} justify={["center"]}>
      {!isNil(social.instagram) &&
        social.instagram &&
        this.renderInstagram(social.instagram)}
      {!isNil(social.facebook) &&
        social.facebook &&
        this.renderFacebook(social.facebook)}
      {!isNil(social.twitter) &&
        social.twitter &&
        this.renderTwitter(social.twitter)}
      {!isNil(social.youtube) &&
        social.youtube &&
        this.renderYoutube(social.youtube)}
    </Flex>
  );

  renderInstagram(instagram) {
    if (!isNil(instagram.id)) {
      return (
        <IconButton
          tooltip={instagram.id}
          iconStyle={styles.mediumIcon}
          style={styles.medium}
          href={convertUrlSocialMedia("instagram", instagram.id)}
          target="_blank"
        >
          <FontIcon className="icon-instagramm" />
        </IconButton>
      );
    }
    return null;
  }
  renderFacebook(facebook) {
    if (!isNil(facebook.id)) {
      return (
        <IconButton
          tooltip={facebook.id}
          iconStyle={styles.mediumIcon}
          style={styles.medium}
          href={convertUrlSocialMedia("facebook", facebook.id)}
          target="_blank"
        >
          <FontIcon className="icon-facebook-squared" />
        </IconButton>
      );
    }
    return null;
  }
  renderTwitter(twitter) {
    if (!isNil(twitter.id)) {
      return (
        <IconButton
          tooltip={twitter.id}
          iconStyle={styles.mediumIcon}
          style={styles.medium}
          href={convertUrlSocialMedia("twitter", twitter.id)}
          target="_blank"
        >
          <FontIcon className="icon-twitter-squared" />
        </IconButton>
      );
    }
    return null;
  }
  renderYoutube(youtube) {
    if (!isNil(youtube.id)) {
      return (
        <IconButton
          tooltip={youtube.id}
          iconStyle={styles.mediumIcon}
          style={styles.medium}
          href={convertUrlSocialMedia("youtube", youtube.id)}
          target="_blank"
        >
          <FontIcon className="icon-youtube-squared" />
        </IconButton>
      );
    }
    return null;
  }

  render() {
    const { basePath, children, record, resource } = this.props;
    return (
      <DivFormContainer>
        {this.renderProfileInfo(basePath, children, record, resource)}
        {record.social && this.renderSocial(record.social)}
        <div style={styles.tabsContainer}>
          <Tabs value={this.state.value} onChange={this.handleChange}>
            <Tab label={"Sales"} value={0}>
              <div style={styles.tabBox}>
                <MarketerSales idMarketer={this.props.record.id} />
              </div>
            </Tab>
            <Tab label={"Transactions"} value={1}>
              <div style={styles.tabBox}>
                <MarketerTransactions idMarketer={this.props.record.id} />
              </div>
            </Tab>
          </Tabs>
        </div>
      </DivFormContainer>
    );
  }
}

const DivFormContainer = Box.extend`
  padding-top: 3em;
  @media only screen and (min-width: 768px) {
    padding-bottom: 1em;
    padding-top: 0em;
  }
`;
MarketerShowLayout.propTypes = {
  basePath: PropTypes.string,
  children: PropTypes.node,
  record: PropTypes.object,
  resource: PropTypes.string,
  style: PropTypes.object,
  setShowButtonAdjust: PropTypes.func,
  selectedDefault: PropTypes.number
};

export default MarketerShowLayout;



// WEBPACK FOOTER //
// ./src/marketers/MarketerShowLayout.js